import React from "react";
import { Route, Routes } from "react-router-dom";
import CareerDashboard from "../../views/career/dashboard/CareerDashboard";
import CareerFormTemplates from "../../views/career/forms/CareerFormTemplates";
import CareerStatuses from "../../views/career/statuses/CareerStatuses";
import CareerLocations from "../../views/career/locations/CareerLocations";
import CareerJobList from "../../views/career/jobs/CareerJobList";
import CareerJobDetail from "../../views/career/jobs/CareerJobDetail";
import JobApplicants from "../../views/career/applications/JobApplicants";
import ApplicationDetail from "../../views/career/applications/ApplicationDetail";
import EligibleStudents from "../../views/career/applications/EligibleStudents";
import CareerApplicantsPage from "../../views/career/applications/CareerApplicantsPage";
import CareerEligiblePage from "../../views/career/applications/CareerEligiblePage";

// Career Connect (officer side) internal routes. Mounted under "career-connect/*"
// in MainRouter.
const CareerRouter = () => {
  return (
    <Routes>
      <Route path="dashboard" element={<CareerDashboard />} />
      <Route path="form-templates" element={<CareerFormTemplates />} />
      <Route path="statuses" element={<CareerStatuses />} />
      <Route path="locations" element={<CareerLocations />} />
      <Route path="jobs" element={<CareerJobList />} />
      {/* sidebar pages: job selector at top */}
      <Route path="applicants" element={<CareerApplicantsPage />} />
      <Route path="eligible-students" element={<CareerEligiblePage />} />
      {/* per-job pages: reached from a job row's buttons */}
      <Route path="jobs/:jobId/eligible-students" element={<EligibleStudents />} />
      <Route path="jobs/:jobId/applicants" element={<JobApplicants />} />
      {/* job detail — click a job title */}
      <Route path="jobs/:jobId" element={<CareerJobDetail />} />
      <Route path="applications/:applicationId" element={<ApplicationDetail />} />
    </Routes>
  );
};

export default CareerRouter;
